export const countryToContinent: Record<string, string> = {
  // Europe
  'AL': 'Europe', 'AD': 'Europe', 'AM': 'Europe', 'AT': 'Europe', 'AZ': 'Europe', 'BY': 'Europe', 'BE': 'Europe',
  'BA': 'Europe', 'BG': 'Europe', 'HR': 'Europe', 'CY': 'Europe', 'CZ': 'Europe', 'DK': 'Europe', 'EE': 'Europe',
  'FI': 'Europe', 'FR': 'Europe', 'GE': 'Europe', 'DE': 'Europe', 'GR': 'Europe', 'HU': 'Europe', 'IS': 'Europe',
  'IE': 'Europe', 'IT': 'Europe', 'KZ': 'Europe', 'XK': 'Europe', 'LV': 'Europe', 'LI': 'Europe', 'LT': 'Europe',
  'LU': 'Europe', 'MT': 'Europe', 'MD': 'Europe', 'MC': 'Europe', 'ME': 'Europe', 'NL': 'Europe', 'MK': 'Europe',
  'NO': 'Europe', 'PL': 'Europe', 'PT': 'Europe', 'RO': 'Europe', 'RU': 'Europe', 'SM': 'Europe', 'RS': 'Europe',
  'SK': 'Europe', 'SI': 'Europe', 'ES': 'Europe', 'SE': 'Europe', 'CH': 'Europe', 'TR': 'Europe', 'UA': 'Europe',
  'GB': 'Europe', 'VA': 'Europe',
  // North America
  'US': 'North America', 'CA': 'North America', 'MX': 'North America', 'GL': 'North America',
  // South America
  'AR': 'South America', 'BO': 'South America', 'BR': 'South America', 'CL': 'South America', 'CO': 'South America',
  'EC': 'South America', 'GF': 'South America', 'GY': 'South America', 'PY': 'South America', 'PE': 'South America',
  'SR': 'South America', 'UY': 'South America', 'VE': 'South America',
};